import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

type WishlistItem = {
  id: number
  title: string
  addedAt: string
}

type State = {
  items: WishlistItem[]
}

type Actions = {
  addItem: (_item: Omit<WishlistItem, 'addedAt'>) => void
  removeItem: (_id: number) => void
  toggleItem: (_item: Omit<WishlistItem, 'addedAt'>) => void
  isInWishlist: (_id: number) => boolean
  clearWishlist: () => void
}

const useWishlistStore = create(
  persist<State & Actions>(
    (set, get) => ({
      items: [],

      addItem: (item) =>
        set((state) => {
          if (state.items.some((i) => i.id === item.id)) {
            return state
          }
          return {
            items: [...state.items, { ...item, addedAt: new Date().toISOString() }]
          }
        }),

      removeItem: (id) =>
        set((state) => ({
          items: state.items.filter((item) => item.id !== id)
        })),

      toggleItem: (item) => {
        const { items, addItem, removeItem } = get()
        if (items.some((i) => i.id === item.id)) {
          removeItem(item.id)
        } else {
          addItem(item)
        }
      },

      isInWishlist: (id) => get().items.some((item) => item.id === id),

      clearWishlist: () => set({ items: [] })
    }),
    {
      name: 'sais-wishlist',
      storage: createJSONStorage(() => localStorage)
    }
  )
)

export { useWishlistStore }
export type { WishlistItem }
